@if (record) {
  <div class="card h-100">
    <div class="card-body">
      <div class="d-flex flex-row">
        <img class="img-50 img-rounded me-1" [src]="record._user.image || profilePics.default" alt="">
        <div class="h5 card-title d-flex flex-column">
          <a class="font-weight-bold" [routerLink]="'/record/' + record._id">{{record.title || 'No title'}}</a>
          <div class="mt-1">
            <a [routerLink]="'/user/' + record._user._id">{{record._user.firstName}} {{record._user.lastName}}</a>
          </div>
        </div>
        <div class="ms-auto my-2 text-nowrap">
          @if (auth.isAdmin || auth.currentUser._id === record._user._id || iAmParticipant || canEditAnyRecord) {
            <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-record-modal" (click)="toggleEditRecordModal(record)"
              >
              <i class="fa fa-pencil"></i> Edit
            </button>
          }
          @if (auth.isAdmin || auth.currentUser._id === record._user._id) {
            <app-delete-btn size="xs" (click)="deleteRecord(record)"></app-delete-btn>
          }
        </div>
      </div>
      <div class="d-flex flex-column">
        <div class="my-1">
          <i class="fa fa-circle fa-fw" [ngClass]="setClassColorByStatus(record.status)"></i> Activity: {{record.activity}} @if (record.feedback) {
          <span>({{record.feedback}})</span>
          } @if (record.format) {
          <span>({{record.format}}) </span>
        }
        <span class="text-uppercase badge rounded-pill ms-1" [ngClass]="setClassByStatus(record.status)">
          {{record.status}} <i class="fa" [ngClass]="setClassByStatusIcon(record.status)"></i>
          @if (record.status === 'Goal achieved') {
            <span class="emoji-tada ms-1"></span>
          }
        </span>
      </div>
      <div class="mb-1">
        <i class="fa fa-calendar fa-fw"></i> Due date: {{record.date | date}}
      </div>
      @if (record.timesheet?.length) {
        <div class="mb-1">
          <i class="fa fa-clock-o fa-fw"></i> Timesheet:
          @for (time of record.timesheet; track time._id; let last = $last) {
            <span>
              @if (time.hours) {
                <a [routerLink]="'/user/' + time._user._id">
                  <img class="img-25 img-rounded" [src]="time._user.image || profilePics.default" alt=""> {{time._user.firstName.substring(0,1)}}. {{time._user.lastName}}
                </a>
              }
              @if (time.hours) {
                <span>({{time.hours}}h)</span>
              }
              @if (!last && time.hours) {
                <span>, </span>
              }
              @if (last) {
                <span>
                  @if (auth.isAdmin || auth.currentUser._id === record._user._id || iAmParticipant || canEditAnyRecord) {
                    <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-record-timesheet-modal" (click)="toggleEditRecordTimesheetModal(record)"
                      >
                      <i class="fa fa-pencil"></i>
                    </button>
                  }
                </span>
              }
            </span>
          }
        </div>
      }
      @if (record.hours) {
        <div class="mb-1">
          <i class="fa fa-clock-o fa-fw"></i> Total hours: {{record.hours}}h
        </div>
      }
      @if (record._created_by._id !== record._user._id) {
        <div class="mb-1">
          <i class="fa fa-user-plus fa-fw"></i> Assigned by:
          <a [routerLink]="'/user/' + record._created_by._id">
            <img class="img-25 img-rounded" [src]="record._created_by.image || profilePics.default" alt=""> {{record._created_by.firstName}} {{record._created_by.lastName}}
          </a>
        </div>
      }
      @if (record._users.length) {
        <div class="mb-1">
          <i class="fa fa-heart fa-fw"></i> Team:
          @for (user of record._users; track user._id; let last = $last) {
            <span>
              <a [routerLink]="'/user/' + user._id">
                <img class="img-25 img-rounded" [src]="user.image || profilePics.default" alt=""> {{user.firstName.substring(0,1)}}. {{user.lastName}}
              </a>
              @if (!last) {
                <span>, </span>
              }
            </span>
          }
        </div>
      }
      @if (record.departments?.length) {
        <div class="mb-1">
          <i class="fa fa-tag fa-fw"></i> Departments: {{record.departments.join(', ')}}
        </div>
      }
      @if (record.moderator) {
        <div class="mb-1">
          <i class="fa fa-user fa-fw"></i> Moderator: {{record.moderator}}
        </div>
      }
      @if (record._politicians.length) {
        <div class="mb-1">
          <i class="fa fa-globe fa-fw"></i> Stakeholders:
          @for (politician of record._politicians; track politician._id; let last = $last) {
            <span>
              <a [routerLink]="'/stakeholder/' + politician._id">
                <img class="img-25 img-rounded" [src]="politician?.image || politician.socials?.twitter?.profile_picture || profilePics.default" alt=""> {{politician.firstName}} {{politician.lastName}}
              </a>
              @if (!last) {
                <span>, </span>
              }
            </span>
          }
        </div>
      }
      @if (record._clients.length) {
        <div class="mb-1">
          <i class="fa fa-users fa-fw"></i> Clients:
          @for (client of record._clients; track client._id; let last = $last) {
            <span>
              <a [routerLink]="'/client/' + client._id">{{client.name}}</a>@if (!last) {
              <span>, </span>
            }
          </span>
        }
      </div>
    }
    @if (record.clients) {
      <div>
        <i class="fa fa-users fa-fw"></i> Client's participants: <span [innerHTML]="formatNotes(record.clients)"></span>
      </div>
    }
    @if (record._organizations?.length) {
      <div class="mt-1">
        <i class="fa fa-building fa-fw"></i> Organizations:
        @for (organization of record._organizations; track organization._id; let last = $last) {
          <span>
            <a [routerLink]="'/organization/' + organization._id">{{organization.name}}</a>@if (!last) {
            <span>, </span>
          }
        </span>
      }
    </div>
  }
  @if (record.notes) {
    <div class="mt-2">
      <i class="fa fa-pencil-square-o fa-fw me-1"></i>Notes:<br>
      <span [innerHTML]="formatNotes(record.notes)"></span>
    </div>
  }
  @if (record.followup === 'yes') {
    <div class="mt-1">
      <i class="fa fa-reply fa-rotate-180 me-1" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Follow up notes"></i> <span [innerHTML]="formatNotes(record.followupnotes)"></span>
    </div>
  }
  @if (record.driveurl) {
    <div class="mt-1">
      <i class="fa fa-paperclip me-1"></i> <a target="_blank" [href]="record.driveurl">Google Drive URL ({{record.driveurl.split('/')?.[2]}})</a>
    </div>
  }
  @if (record.externalurl) {
    <div class="mt-1">
      <i class="fa fa-link me-1"></i> <a target="_blank" [href]="record.externalurl">External URL ({{record.externalurl.split('/')?.[2]}})</a>
    </div>
  }
  @if (record.externalurl2) {
    <div class="mt-1">
      <i class="fa fa-link me-1"></i> <a target="_blank" [href]="record.externalurl2">External URL ({{record.externalurl2.split('/')?.[2]}})</a>
    </div>
  }
</div>
<div class="d-flex flex-row mt-2">
  <div class="">
    <a class="btn btn-primary btn-sm py-0 px-1 hide-print" role="button" [routerLink]="'/record/' + record._id">
      <i class="fa fa-comments"></i> Comments ({{record.comments.length}})
    </a>
  </div>
  <div class="ms-auto">
    <a class="small text-muted" [routerLink]="'/record/' + record._id">
      added on {{record.created_at | date}}
      @if (record.updated_at) {
        <i class="fa fa-clock-o cursor-pointer" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="updated on {{record.updated_at | date}}"></i>
      }
    </a>
  </div>
</div>
</div>
</div>
}
@if (isDetailsPage) {
  <div>
    <div class="card mt-2 hide-print">
      <div class="card h-100 border border-primary cursor-pointer" data-bs-toggle="modal" data-bs-target="#add-comment-modal" (click)="toggleAddCommentModal()">
        <div class="card-body">
          <h5 class="card-title">
            <div class="d-flex align-items-center justify-content-center mh-80">
              <div class="text-primary">
                <i class="fa fa-plus-circle me-1"></i>
                Add comment
              </div>
            </div>
          </h5>
        </div>
      </div>
    </div>
    @for (comment of record.comments; track comment._id) {
      <div class="card mt-2">
        <div class="card-body">
          <div class="d-flex flex-row">
            <div class="h5 card-title">
              <a [routerLink]="'/user/' + comment._user._id">
                <img class="img-25 img-rounded" [src]="comment._user.image || profilePics.default" alt=""> {{comment._user.firstName}} {{comment._user.lastName}}
              </a>
            </div>
            <div class="ms-auto text-nowrap">
              @if (auth.isAdmin || auth.currentUser._id === comment._user._id) {
                <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-comment-modal" (click)="toggleEditCommentModal(comment)"
                  >
                  <i class="fa fa-pencil"></i> Edit
                </button>
              }
              @if (auth.isAdmin || auth.currentUser._id === comment._user._id) {
                <app-delete-btn size="xs" (click)="deleteComment(record, comment)"></app-delete-btn>
              }
            </div>
          </div>
          <div class="d-flex flex-column">
            <p [innerHTML]="formatNotes(comment.text)"></p>
            <div class="ms-auto">
              <span class="small text-muted">
                added on {{comment.created_at | date}}
                @if (comment.updated_at) {
                  <i class="fa fa-clock-o cursor-pointer" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="updated on {{comment.updated_at | date}}"></i>
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}

@if (isCommentModalVisible.add) {
  <app-add-comment-modal [record]="record"></app-add-comment-modal>
}
@if (isCommentModalVisible.edit) {
  <app-edit-comment-modal [record]="record" [comment]="comment"></app-edit-comment-modal>
}
@if (isEditRecordModalVisible) {
  <app-edit-record-modal [record]="record" [clients]="clients"></app-edit-record-modal>
}
@if (isEditRecordTimesheetModalVisible) {
  <app-edit-record-timesheet-modal [record]="record"></app-edit-record-timesheet-modal>
}